import { RecipeIngredientMeasurement } from '../../../../interfaces/RecipeIngredient';
import { RecipeMacros } from '../../../../interfaces/RecipeMacros';
import { RECIPE_MACRO_KEYS } from '../../constants/recipeMacros';
import { RecipeIngredientUnitMacros } from '../../interfaces/RecipeFormValues';

export const pickMacros = (source: RecipeMacros): RecipeMacros =>
  Object.fromEntries(RECIPE_MACRO_KEYS.map((key) => [key, source[key]])) as RecipeMacros;

/**
 * The backend spells the key `calorie` on food and recipe values but `calories` on measurement rows
 * (Nutritionix shape). Form state keeps the API's `calorie`, so `RECIPE_MACRO_KEYS` reads every
 * macros object the same way.
 */
export const measurementToUnitMacros = ({
  unit,
  calories,
  ...macros
}: RecipeIngredientMeasurement): RecipeIngredientUnitMacros => ({
  ...pickMacros({ ...macros, calorie: calories }),
  unit,
});
